import axios, { AxiosError, InternalAxiosRequestConfig } from 'axios';
import { useAuthStore } from '@/store/authStore';

let isRedirecting = false;

// Intercepteur de réponse pour gérer les erreurs 401
export const setupResponseInterceptor = () => {
  axios.interceptors.response.use(
    (response) => response,
    (error: AxiosError) => {
      // Vérifier si c'est une erreur 401 (Unauthorized)
      if (error.response?.status === 401) {
        // Ne pas rediriger si c'est une requête de login (endpoint /session)
        // car un 401 sur /session signifie simplement que les credentials sont incorrects
        const requestUrl = error.config?.url || '';
        const isLoginRequest = requestUrl.includes('/session') && error.config?.method === 'post';
        
        if (!isLoginRequest && !isRedirecting) {
          isRedirecting = true;
          
          // Déconnecter l'utilisateur
          const authStore = useAuthStore.getState();
          authStore.resetState();
          
          // Rediriger vers la page de login
          // Utiliser window.location pour forcer un rechargement complet
          // et éviter les problèmes de navigation avec React Router
          if (window.location.pathname !== '/login') {
            window.location.href = '/login';
          }
          
          // Réinitialiser le flag après un délai pour permettre de nouvelles redirections si nécessaire
          setTimeout(() => {
            isRedirecting = false;
          }, 1000);
        }
      }
      
      // Propager l'erreur pour qu'elle soit gérée par le code appelant
      return Promise.reject(error);
    }
  );
};

// Intercepteur de requête pour ajouter le token (optionnel, déjà géré dans Client.ts)
export const setupRequestInterceptor = () => {
  axios.interceptors.request.use(
    (config: InternalAxiosRequestConfig) => {
      // Le token est déjà ajouté dans Client.ts via headers()
      // Cet intercepteur peut être utilisé pour d'autres besoins (logging, etc.)
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );
};

